import PageHeader from "@/components/PageHeader";
import { ArrowUpRight, Check } from "lucide-react";

const CDN = "https://images.squarespace-cdn.com/content/v1/5efe5eb3e2b42d3ef73d0dc7";
const img = (p) => `${CDN}/${p}?format=1000w`;

const CLASSES = [
  {
    key: "improv-for-all-online",
    name: "Improv For All \u2014 Online",
    price: "from $20",
    img: img("ee718821-d21a-4ef8-bea8-f52fe1bf5966/IFA+Main+Purchase+PNG.png"),
    blurb: "Join an Improvaneer Method class from anywhere! New participants are always welcome. A pay-per-class model \u2014 the more classes you buy, the lower the cost per class.",
    bullets: ["Class types: Improv & Beyond, Base Camp, Summit, Campfire & Youth", "Buy 1, 5, 10, 25 or 40 classes", "Unused classes roll over to future sessions"],
    href: "https://www.theimprovaneermethod.com/purchase/p/improv-for-all-online",
  },
  {
    key: "live-adult-classes",
    name: "NE Ohio Live Adult Classes",
    price: "$275",
    img: img("1704829663068-4RZO3OI413PXDH44A7LL/Chuckle+Berries+Group+Photo.jpg"),
    blurb: "Fully inclusive, in-person classes for ALL abilities, led by a certified Improvaneer Method Director. Each live session includes up to 10 classes.",
    bullets: ["Locations: Independence, Akron, Medina & North Canton", "Up to 10 classes per session", "Run by a certified Director (+ assistant when available)"],
    href: "https://www.theimprovaneermethod.com/purchase/p/live-adult-classes",
  },
  {
    key: "pop-up-classes",
    name: "Pop-Up Classes in Ohio",
    price: "from $28",
    img: img("1713903893132-897DSNXN8EM4BU7ZKXCZ/Maggie%27s+%26+More+Group%3ALiz.jpg"),
    blurb: "A 75\u201390 minute preview of our full 10-week program, designed for individuals of all abilities aged 16 and up. A fun, supportive glimpse at Improvaneer Method programming.",
    bullets: ["Single class $28 \u2014 or bundle all 4 for $100", "Locations: Weathervane Akron & Improv Cincinnati", "Great first step before a full session"],
    href: "https://www.theimprovaneermethod.com/purchase/p/pop-up-classes",
  },
  {
    key: "private-sessions",
    name: "Private Sessions & Parties",
    price: "from $60",
    img: img("1605465022376-LCOMYLYUUBZJJYTJ8G6S/Rob%2CChris%2CNick+-+Reduced.jpg"),
    blurb: "Book private one-on-one sessions, small groups of up to 4, or parties for up to 20 people. Reach out first so we can tailor topics, focus, dates and times.",
    bullets: ["1:1 sessions (30 or 60 minutes)", "Small groups \u2014 blocks of 5", "Parties of up to 20 people (60\u201390 min)"],
    href: "https://www.theimprovaneermethod.com/purchase/p/qi2tn2fncjr3mjs950tvw4v7ktrp3z",
  },
];

export default function Classes() {
  return (
    <div data-testid="classes-page">
      <PageHeader eyebrow="Join a Class" title="Classes & sessions"
        subtitle="Find the right Improvaneer Method experience — online, in person, pop-up, or private. Choose an option below to see live dates and register." />
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {CLASSES.map((c) => (
            <a key={c.key} href={c.href} target="_blank" rel="noopener noreferrer"
              data-testid={`class-card-${c.key}`}
              className="group flex flex-col bg-white rounded-2xl border border-[#dfd8da] overflow-hidden hover:border-[#920e12] hover:shadow-lg transition-all duration-150">
              <div className="relative aspect-[16/9] bg-[#1a1617] overflow-hidden">
                <img src={c.img} alt={c.name} loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-200 group-hover:scale-105" />
                <span className="absolute top-3 right-3 px-3 py-1 rounded-full bg-[#920e12] text-white text-sm font-extrabold shadow">{c.price}</span>
              </div>
              <div className="flex-1 flex flex-col p-6">
                <h2 className="text-2xl font-bold text-[#1a1617] group-hover:text-[#920e12]">{c.name}</h2>
                <p className="mt-2 text-sm text-[#545454] leading-relaxed">{c.blurb}</p>
                <ul className="mt-4 space-y-1.5">
                  {c.bullets.map((b) => (
                    <li key={b} className="flex items-start gap-2 text-sm text-[#1a1617]">
                      <Check size={16} className="mt-0.5 text-[#920e12] shrink-0" aria-hidden="true" /> {b}
                    </li>
                  ))}
                </ul>
                <span className="mt-6 inline-flex items-center gap-1.5 font-bold text-[#920e12]">
                  View dates & register <ArrowUpRight size={18} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" aria-hidden="true" />
                </span>
              </div>
            </a>
          ))}
        </div>
        <p className="mt-10 text-center text-sm text-[#545454]">
          Registration and payment are handled on our secure site. New to a live class?{" "}
          <a href="mailto:liz@theimprovaneermethod.com" className="font-semibold text-[#920e12] hover:underline">Email us</a> and we'll help you find a spot.
        </p>
      </div>
    </div>
  );
}
